import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoriesComponent } from './stories.component';
import { RouterModule, Routes } from '@angular/router';
import { StoryPageComponent } from '../../../public/views/stories/story-page/story-page.component';
import { SharedModule } from '../../../shared/shared.module';
import { EditStoryComponent } from './edit-story/edit-story.component';
import { StoryPageModule } from '../../../public/views/stories/story-page/story-page.module';
import { EditStoryModule } from './edit-story/edit-story.module';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { StoryTitleModule } from '../../../shared/components/story-title/story-title.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";

const ANGULAR_MATERIAL_MODULES = [
  MatIconModule, MatChipsModule, MatFormFieldModule, MatSelectModule,
  MatButtonModule, MatAutocompleteModule
];

const COMPONENTS = [StoriesComponent];

export const privateStories_nav_path = {};

const routes: Routes = [
  { path: '', component: StoriesComponent, pathMatch: 'full' },
  { path: ':storyID', component: StoryPageComponent },
  { path: ':storyID/edit', component: EditStoryComponent }
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    RouterModule.forChild(routes), CommonModule, StoryPageModule, EditStoryModule,
    ...ANGULAR_MATERIAL_MODULES, SharedModule, StoryTitleModule, ReactiveFormsModule
  ],
  exports: [RouterModule],
  providers: []
})
export class PrivateStoriesModule { }
